<template>
  <div>
    <div class="message-status" v-bind:class="{active: messageError}">
      <span>An error has occurred. Please try again!</span>
    </div>
    <div class="message-loading-group" v-bind:class="{active: loadingForm}">
      <div class="message-loading-div">
        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
        <div class="message-text-loading">Loading, please wait...</div>
      </div>
    </div>
    <modal
      name="showMessageSetStore"
      :adaptive="true"
      height="auto"
      width="450"
      :reset="true"
      style="max-width:100%"
      class="showMessageSetStore"
      >
      <div class="show-message-set-store-container">
        <p><img src='https://d7re1xv4rs2gf.cloudfront.net/d6543119-8ba9-11ef-8fa3-366e99cc6050__custom-oopprint-let-time.jpg' width='180' alt='Custom oopprint let time'></p>
        <h3 class="h3-let-time">Let us help save your time!</h3>
        <p class="p1-let-time">You have a previous customization.</p>
        <p class="show-message-set-store-message">Do you want to auto-fill that customization?.</p>
        <div class="show-message-set-store-group-button">
          <div @click="handleStartNew" class="btn_start_new">Start New</div>
          <div @click="handleContinueEdit" class="btn_continue_edit">Continue Editing</div>
        </div>
      </div>
    </modal>
    <FormulateForm
      v-model="formValues"
      class="omcustom-form"
      ref="artworkForm"
      @input="checkValidation"
    >
      <template v-for="layer in layers">
        <layer-form-item
          v-if="checkCondition(layer)"
          :key="layer.id"
          :layer="layer"
          :artwork="artwork"
          :personalized="artworkData"
          @ChangeApplySky="ChangeApplySky"
          @ChangeGroupApplySky='ChangeApplySky'
          @ChangeTextMapChild='ChangeTextMapChild'
          @ChangeTextSongLyric="ChangeTextSongLyric"
          @changeTextMoonPhase="ChangeTextMoonPhase"
        />
      </template>
    </FormulateForm>
  </div>
</template>
<script>
import { get, debounce, cloneDeep, orderBy } from 'lodash'
import LayerFormItem from './Form/LayerFormItem'
import { mapGetters, mapMutations } from 'vuex'
import { checkCondition, isDevMode, customDecode } from '@/helper/helper'

export default {
  name: 'artwork-form',
  components: {
    LayerFormItem
  },
  props: {
    artwork: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formValues: {},
      preview: false,
      errors: {}
    }
  },
  created() {
    const { personalized, artwork, initValues, product } = this
    this.formValues = { ...initValues, ...get(personalized, artwork.id, {}) }
    // Từng gọi RenderTextLoop ở đây (2022, "fix_text_load"): với mỗi layer
    // chữ, sau 0,5s thêm "ㅤ" rồi 1s xoá đi để ép vẽ lại khi font về muộn —
    // mỗi layer chữ = 2 lần vẽ lại toàn bộ preview, và có thể ghi đè chữ khách
    // vừa nhập bằng chữ mặc định. Text.vue nay tự chờ loadFont rồi vẽ lại, nên
    // đã bỏ (preview cuối giống hệt, kể cả khi font tải chậm).

    const product_id = get(product, 'id', null);
    const dataStoreByProduct = localStorage.getItem(`store-layers-${product_id}`);
    if(product_id && dataStoreByProduct){
      setTimeout(() => {
        this.$modal.show('showMessageSetStore');
      }, 1000);
    }
  },
  mounted() {
    this.$refs.artworkForm.$emit('input', this.formValues)
  },
  watch: {
    formValues(data) {
      const { artwork } = this
      this.setPersonalized({ artworkID: artwork.id, data })
    },
    messageError(value){
      if(value == true){
        setTimeout(() => {
          this.setMessageError(false);
        }, 4000)
      }
    }
  },
  computed: {
    ...mapGetters([
      'settings',
      'personalized',
      'ratios',
      'artworks',
      'getPersonalizedText',
      'getPersonalizedText',
      'messageError',
      'loadingForm',
      'product'
    ]),
    layers() {
      const { artwork } = this
      var layers = cloneDeep(artwork.templates[0].layers)
      return orderBy(layers.reverse(), l => l.ordering || 0)
    },
    initValues() {
      const { layers } = this
      var initValues = {}
      layers
        .filter(l => l.type === 'Option')
        .forEach(l => {
          var defaultOp = l.options.find(o => o.default)
          if (defaultOp) {
            initValues[l.id] = defaultOp.value
          }
        })
      return initValues
    },
    artworkData() {
      const { personalized, artwork } = this
      return get(personalized, artwork.id, {})
    }
  },
  methods: {
    ...mapMutations(['setPersonalized', 'setMessageError', 'setLoadingMedia', 'setArtworks', 'setIsSaveLocalstorage', 'setCartData']),
    isDevMode: isDevMode,
    handleContinueEdit(){
      this.setIsSaveLocalstorage(true);
      const {product} = this;
      const product_id = get(product, 'id', null);
      let dataStoreByProduct = localStorage.getItem(`store-layers-${product_id}`);
      if(product_id && dataStoreByProduct){
        dataStoreByProduct = customDecode(dataStoreByProduct, product_id.toString());
        let data = JSON.parse(dataStoreByProduct);
        // console.log('dataStoreByProduct', dataStoreByProduct);
        data = data[this.artworks[0].id];
        this.formValues = { ...this.formValues, ...data };
        this.$modal.hide('showMessageSetStore');
      }
      let cartDataRoot = localStorage.getItem(`cart-data-root-${product_id}`);
      if(product_id && cartDataRoot){
        cartDataRoot = customDecode(cartDataRoot, product_id.toString());
        cartDataRoot = JSON.parse(cartDataRoot);
        // console.log('cartDataRoot', cartDataRoot);
        this.setCartData(cartDataRoot);
      }
    },
    handleStartNew(){
      const {product} = this;
      const product_id = get(product, 'id', null);
      localStorage.removeItem(`store-layers-${product_id}`);
      this.$modal.hide('showMessageSetStore');
    },
    checkCondition(layer) {
      const { artworkData, layers } = this
      return checkCondition(layer, artworkData, layers)
    },
    onValuesChange: debounce(function(_, value) {
      this.$emit('input', { ...this.data, ...value })
      const errors = this.form.getFieldsError()
      var error = false
      for (let field in errors) {
        if (errors[field]) {
          error = true
          break
        }
      }
      this.$emit('error', error)
    }, 100),
    async checkValidation() {
      if (this.$refs.artworkForm) {
        var hasErrors = await this.$refs.artworkForm.hasValidationErrors()
        this.$emit('error', hasErrors)
      }
    },
    ChangeTextMoonPhase(data){
      if(!data.id) return;
      const getPersonalizedText = this.getPersonalizedText;
      const updates = {};
      getPersonalizedText.filter((e) => e.parent == data.id).forEach(layer => {
        switch (layer.type) {
          case "textMoonPhaseDate":
            updates[layer.id] = data.date || this.formValues[layer.id];
            break;
          case "textMoonPhaseAddress":
            updates[layer.id] = data.address || this.formValues[layer.id];
            break;
          case "textMoonPhaseCoordinates":
            updates[layer.id] = data.coordinates || this.formValues[layer.id];
            break;
          default:
            break;
        }
      });
      
      if(Object.keys(updates).length){
        this.formValues = { ...this.formValues, ...updates };
      }
    },
    ChangeApplySky(data){
      if(data.id){
        const getPersonalizedText = this.getPersonalizedText;
        const updates = {};
        const SearchAddress = getPersonalizedText.find((e) => e.parent == data.id && e.type == "SkyAddress");
        if(SearchAddress && data.address != null){
            updates[SearchAddress.id] = data.address;
        }
        const SearchDate = getPersonalizedText.find((e) => e.parent == data.id && e.type == "SkyDate");
        if(SearchDate && data.date != null){
            updates[SearchDate.id] = data.date;
        }
        const SearchCoordinates = getPersonalizedText.find((e) => e.parent == data.id && e.type == "CoordinatesStar");
        if(SearchCoordinates && data.Coordinates != null){
            updates[SearchCoordinates.id] = data.Coordinates;
        }
        if(Object.keys(updates).length){
          this.formValues = { ...this.formValues, ...updates };
        }
      }
    },
    ChangeTextMapChild(data){
      if(data.id != null){
        const id = data.id;
        const getPersonalizedText = this.getPersonalizedText;
        const updates = {};
        const searchCoordinates = getPersonalizedText.find((e) => e.parent == id && e.type == "CoordinatesMap");
        if(searchCoordinates && data.Coordinates != null){
            updates[searchCoordinates.id] = data.Coordinates;
        }
        const searchID = getPersonalizedText.find((e)=> e.parent == id);
        if(searchID){
          if(searchID.type == "SkyDate" || searchID.type == "LocationMap"){
            if(data.Location != null){
              updates[searchID.id] = data.Location;
            }
          }
        }
        if(Object.keys(updates).length){
          this.formValues = { ...this.formValues, ...updates };
        }
      }
    },
    ChangeTextSongLyric(data){
      if(data.id != null){
        const id = data.id;
        const getPersonalizedText = this.getPersonalizedText;
        const searchLayerTextLyric = getPersonalizedText.find((e) => e.parent == id && e.type == 'TitleSongLyric');
        if(searchLayerTextLyric && data.SongName != null){
          this.formValues = { ...this.formValues, [searchLayerTextLyric.id]: data.SongName };
        }
      }
    }
  }
}
</script>

<style scoped>
.personalized-form .ant-form-item {
  margin-bottom: 20px;
}
.btn-preview {
  display: block;
  width: 100%;
  margin-bottom: 10px;
}
.message-status{
  position: fixed;
  background-color: red;
  color: yellow;
  padding: 5px 10px;
  right: 5px;
  top: -140px;
  border-radius: 5px;
  box-shadow: 0px 0px 5px -1px rgb(41, 41, 41);
  transition: 0.5s;
  z-index: 9999999999;
}
.message-status.active{
  top: 5px;
}


.message-text-loading {
  color: #e1e1e1;
  font-weight: 500;
  text-shadow: 0px 0px 5px #0000007d;
}
.message-loading-group {
  position: fixed !important;
  top: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  background: #5b5b5b87 !important;
  z-index: 9999999999999999 !important;
}

.message-loading-div {
  margin: 0 auto !important;
  width: 100% !important;
  text-align: center !important;
  position: absolute !important;
  top: 50% !important;
}
.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.show-message-set-store-container {
    padding: 15px;
    text-align: center;
}
.show-message-set-store-group-button {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 25px;
}

.show-message-set-store-group-button > div {
    width: 48%;
    background: #d26e4b;
    padding: 7px 0;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}

.btn_continue_edit {
    background: #09a81b !important;
    color: #ffffff !important;
    font-weight: 500 !important;
}
.h3-let-time{
  font-size: 24px;
  margin-top: -5px;
  margin-bottom: 15px;
}
.p1-let-time{
  margin-bottom: 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/ArtworkForm.vue